import { EndpointToolFormValues } from '@/models/ops/endpoints/EndpointTool.model';
import ApiService from '@/services/Api.service';

export class EndpointToolService {
  static async makeRequest(values: EndpointToolFormValues): Promise<any> {
    const { endpoint, payload } = values;
    let response;

    switch (endpoint.method) {
      case 'GET':
        response = await ApiService.getJson(endpoint.url);
        break;
      case 'POST':
        response = await ApiService.postJson(endpoint.url, JSON.parse(payload));
        break;
      case 'PUT':
        response = await ApiService.putJson(endpoint.url, JSON.parse(payload));
        break;
      default:
        throw new Error(`Unsupported HTTP method: ${endpoint.method}`);
    }

    return response;
  }
}
